import { CustomFile } from 'src/app/message/model/custom-file';

export class Task
{
    public id: number;
    public name: string;
    public assignee: any;
    public assigneeName: string;
    public description: string;
    public dueDate: Date;
    public openedOn: Date;
    public priority: string;
    public priorityNumber: string;
    public processDefinitionId: string;
    public caseId: number;
    public eventId: number;
    public followUpTaskId: number;
    public memberId: number;
    public channelId: number;
    public assessmentId: number;
    public assessment: any;
    public files: CustomFile[];
    public note: any;
}

export class TaskCategory
{
    public patientcontact: string;
    public contactcodeset: number;
    public initiativecodeset: number;
    public areacodeset: number;
    public dropdownoutcome: string;
    public assessment: number;
    public feecategory: number;
    public feeschedule: number;
    public private: string;
    public checkaccumulator: string;
}
